import React from 'react';
import { problems } from '../../data/crm';
export function CrmProblems() {
  return <section className="bg-brand-black px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-40" data-mp="1klf4twpr1fxe">
      <div className="mx-auto max-w-7xl" data-id="element-41" data-mp="1kni4l8gpenfb">
        <h2 className="max-w-2xl text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-42" data-mp="15xkbqf7tx9js">
          Where your money is leaking right now
        </h2>
        <div className="mt-12 grid gap-px overflow-hidden rounded-2xl bg-white/10 md:grid-cols-3" data-id="element-43" data-mp="1atj6qlnnxpt6">
          {problems.map(problem => <article key={problem.title} className="flex flex-col bg-brand-black p-8 lg:p-10" data-id="element-44" data-mp="23jhxqmlf3x0h">
              <problem.icon className="h-7 w-7 text-brand-red" strokeWidth={1.75} aria-hidden="true" data-id="element-45" data-mp="1pljjrib0e2li" />
              <h3 className="mt-6 text-xl font-bold text-white" data-id="element-46" data-mp="1tlbwm77fquwo">{problem.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-brand-light" data-id="element-47" data-mp="e53cic9lys9q">{problem.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}